/**
 * This is the entry file for webpack/config/front.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();

// Cookies
import '/node_modules/vanilla-cookieconsent/dist/cookieconsent.js';

// Icons
import '/node_modules/feather-icons/dist/feather.min';

// Owl-carousel
import '/node_modules/owl.carousel/dist/owl.carousel.js';

// Model-viewer
import '@google/model-viewer';

// GSAP & ScrollTrigger
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// Application
import '/webpack/assets/js/front/flashMessenger.js';
import '/webpack/assets/js/front/netteFormsExtension.js';
import '/webpack/assets/js/front/animation.js';
import '/webpack/assets/js/front/general.js';
import '/webpack/assets/js/front/navbar.js';
import '/webpack/assets/js/front/homepage.js';
import '/webpack/assets/js/front/meetTheTeam.js';
import '/webpack/assets/js/front/guidelines.js';
import '/webpack/assets/js/front/contact.js';
import '/webpack/assets/js/front/career.js';
import '/webpack/assets/js/front/caseStudy.js';
import '/webpack/assets/js/front/howWeWork.js';
import '/webpack/assets/js/front/ourStory.js';
import '/webpack/assets/js/front/owl.carousel.js';
